/**
 * Utility functions for handling Telegram authentication (desktop Login Widget)
 */

export interface TelegramAuthData {
  id: string;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: string;
  hash: string;
  [key: string]: string | undefined;
}

/**
 * Check if Telegram Login Widget auth data is expired (older than 24 hours)
 */
export const isAuthDataExpired = (authData: TelegramAuthData): boolean => {
  const authDate = parseInt(authData.auth_date);
  const currentTime = Math.floor(Date.now() / 1000);
  return currentTime - authDate > 86400;
};

/**
 * Get valid auth data from localStorage, returns null if expired or invalid
 */
export const getValidAuthData = (): TelegramAuthData | null => {
  const loginWidgetDataStr = localStorage.getItem('telegram_login_widget_data');

  if (!loginWidgetDataStr) {
    return null;
  }

  try {
    const authData = JSON.parse(loginWidgetDataStr) as TelegramAuthData;

    if (isAuthDataExpired(authData)) {
      localStorage.removeItem('telegram_login_widget_data');
      return null;
    }

    return authData;
  } catch (e) {
    console.error('Failed to parse auth data:', e);
    localStorage.removeItem('telegram_login_widget_data');
    return null;
  }
};

/**
 * Check if we have valid authentication (either WebApp or Login Widget)
 */
export const hasValidAuth = (): boolean => {
  if (window.Telegram?.WebApp?.initData) {
    return true;
  }
  return getValidAuthData() !== null;
};
